import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import TextPageWrapper from '..';
export default function PrivacyPolicyPage() {
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(TextPageWrapper, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h2"
  }, t('general.privacy_policy')), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('general.privacy_policy_body')));
}